import LOGO from "../images/rwe.png";

export const Team__RWE = {
  name: "RWE",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#ff8928ff",
  teamJerseyColor: "#0E293D",

  // Stats
  gamesWon: 0,
  gamesLost: 3,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 43 + 36 + 48,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 28 + 23 + 36,
    },
  ],
};
